// @ts-nocheck
/**
 * Virtual Try-On — Auto Bottom Sheet
 *
 * On mobile (viewport < 750px):
 *   1. After the page fully loads, looks for the Icona Virtual Try-On
 *      element inside .product-app-blocks.
 *   2. Per-product: auto-opens the drawer up to MAX_PRODUCT_SHOWS times.
 *   3. Global cap: after MAX_CLOSE_COUNT total dismissals, stops entirely.
 *   4. Resets all counts on browser close (sessionStorage) or after
 *      INACTIVITY_MS of no page loads.
 *
 * On desktop: does nothing — .product-app-blocks renders inline as-is.
 */

(function () {
  var STORAGE_KEY       = 'vto_data';
  var MAX_PRODUCT_SHOWS = 2;
  var MAX_CLOSE_COUNT   = 3;
  var INACTIVITY_MS     = 30 * 60 * 1000; // 30 minutes
  var MOBILE_BP         = 750;
  var OPEN_DELAY_MS     = 800;

  // ── Element refs ──────────────────────────────────────────────────────────
  var sheet     = document.getElementById('vto-auto-sheet');
  var overlay   = document.getElementById('vto-overlay');
  var closeBtn  = document.getElementById('vto-close');
  var sheetBody = document.getElementById('vto-body');

  if (!sheet || !sheetBody) return;

  var hasLoginGate = sheet.hasAttribute('data-vto-login-gate');

  // ── Helpers ───────────────────────────────────────────────────────────────

  function isMobile() {
    return window.innerWidth < MOBILE_BP;
  }

  function freshData() {
    return { products: {}, closeCount: 0, lastActivity: Date.now() };
  }

  function getData() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return freshData();
      var data = JSON.parse(raw);
      if (Date.now() - data.lastActivity > INACTIVITY_MS) return freshData();
      return data;
    } catch (e) {
      return freshData();
    }
  }

  function saveData(data) {
    data.lastActivity = Date.now();
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  function getProductKey() {
    return window.location.pathname;
  }

  function shouldShow(data) {
    if (data.closeCount >= MAX_CLOSE_COUNT) return false;
    var shown = data.products[getProductKey()] || 0;
    return shown < MAX_PRODUCT_SHOWS;
  }

  /**
   * Find the Icona VTO element.
   * Tries multiple selectors in order of specificity to handle any typos
   * or version differences in the app's rendered HTML.
   */
  function findVTOElement() {
    return (
      document.getElementById('icona-virtual-try-on')    ||
      document.getElementById('icona-virual-try-on')     ||   // app typo variant
      document.querySelector('[id*="icona"][id*="try"]') ||
      document.querySelector('[id*="icona-vto"]')        ||
      document.querySelector('.icona-virtual-try-on')    ||
      null
    );
  }

  /**
   * Find the .product-app-blocks wrapper (we move the whole container
   * so the app's internal event listeners stay intact).
   */
  function findAppBlocksContainer() {
    return document.querySelector('.product-app-blocks');
  }

  // ── Open / close ──────────────────────────────────────────────────────────

  var appBlocksEl       = null;
  var originalParent    = null;
  var originalNextSib   = null;
  var isOpen            = false;

  function openSheet() {
    if (isOpen) return;
    if (!isMobile()) return; // hard guard — never open on desktop

    if (hasLoginGate) {
      // Login gate mode: body already contains login button from Liquid
    } else {
      // Normal mode: move app blocks into sheet body
      appBlocksEl     = findAppBlocksContainer();
      if (!appBlocksEl) return;

      originalParent  = appBlocksEl.parentElement;
      originalNextSib = appBlocksEl.nextElementSibling;

      appBlocksEl.classList.add('vto-in-sheet');
      sheetBody.appendChild(appBlocksEl);
    }

    sheet.hidden = false;
    document.body.style.overflow = 'hidden';
    isOpen = true;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sheet.classList.add('vto-sheet--open');
      });
    });
  }

  function closeSheet() {
    if (!isOpen) return;

    sheet.classList.remove('vto-sheet--open');
    document.body.style.overflow = '';

    // Wait for CSS transition, then clean up
    sheet.addEventListener('transitionend', function onEnd(e) {
      // Only act on the panel's transform transition
      if (!e.target.classList.contains('vto-sheet__panel')) return;
      sheet.removeEventListener('transitionend', onEnd);

      sheet.hidden = true;
      isOpen = false;

      var data = getData();
      var key  = getProductKey();
      data.products[key] = (data.products[key] || 0) + 1;
      data.closeCount    = (data.closeCount || 0) + 1;
      saveData(data);

      // Move app block back to its original DOM position
      if (appBlocksEl) {
        appBlocksEl.classList.remove('vto-in-sheet');
        if (originalNextSib && originalNextSib.parentElement === originalParent) {
          originalParent.insertBefore(appBlocksEl, originalNextSib);
        } else if (originalParent) {
          originalParent.appendChild(appBlocksEl);
        }
        appBlocksEl = null;
      }
    });
  }

  // ── Event listeners ───────────────────────────────────────────────────────

  if (overlay)  overlay.addEventListener('click', closeSheet);
  if (closeBtn) closeBtn.addEventListener('click', closeSheet);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeSheet();
  });

  // ── Wait for VTO element, then auto-open ──────────────────────────────────

  /**
   * The Icona app may inject its element asynchronously.
   * We use a MutationObserver with a hard timeout to catch it.
   */
  function waitForVTOAndOpen() {
    if (!isMobile()) return;

    var data = getData();
    saveData(data); // stamp lastActivity on every page load
    if (!shouldShow(data)) return;

    // Login gate mode: open immediately (login button pre-populated in Liquid)
    if (hasLoginGate) {
      setTimeout(openSheet, OPEN_DELAY_MS);
      return;
    }

    // Check immediately first
    if (findVTOElement()) {
      setTimeout(openSheet, OPEN_DELAY_MS);
      return;
    }

    // Otherwise observe DOM mutations
    var observer = new MutationObserver(function (mutations, obs) {
      if (findVTOElement()) {
        obs.disconnect();
        setTimeout(openSheet, OPEN_DELAY_MS);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Give up after 5 seconds (app not present / disabled for this product)
    setTimeout(function () { observer.disconnect(); }, 5000);
  }

  // ── Initialise ────────────────────────────────────────────────────────────

  if (document.readyState === 'complete') {
    waitForVTOAndOpen();
  } else {
    window.addEventListener('load', waitForVTOAndOpen);
  }
})();

